'use client'
import "./chunk-PRBYVLPX.mjs";
import {
  useCookieConsent
} from "./chunk-KEAZZDYW.mjs";
import {
  context_default,
  useAnalytics_default
} from "./chunk-XDJBAJOL.mjs";
import "./chunk-4HLMV3ZK.mjs";
import {
  GtmTracker
} from "./chunk-7W4DFW4L.mjs";
import {
  ReactNativeTracker
} from "./chunk-AAL7R3RY.mjs";
import "./chunk-DWZ2B3MK.mjs";
import {
  WbkTracker
} from "./chunk-XTG4I32S.mjs";
import {
  getAnalyticsUtms
} from "./chunk-LOKZ6BXB.mjs";
import {
  MixpanelTracker
} from "./chunk-225ZGXBI.mjs";
import {
  PostHogTracker
} from "./chunk-LF7UA7RJ.mjs";
import "./chunk-AJKNY6KO.mjs";
import "./chunk-4RITNUKZ.mjs";
import "./chunk-42IJP2PI.mjs";
import {
  CONSENT_COOKIE_NAME
} from "./chunk-T2NN7R53.mjs";
import {
  __async
} from "./chunk-BTG5EALA.mjs";

// src/context/provider.tsx
import { useEffect, useState } from "react";
import { getItem, readCookie, safeParseJson, setItem } from "@wbk/utils";
import { jsx } from "react/jsx-runtime";
var AnalyticsProvider = ({ children, trackers, currentLocation }) => {
  const [subscribers] = useState(trackers);
  const [showConsent, setShowConsent] = useState(false);
  useEffect(() => {
    const utms = getAnalyticsUtms();
    if (utms) {
      setItem("utms", JSON.stringify(utms));
    }
  }, []);
  useEffect(() => {
    if (typeof navigator !== "undefined") {
      const savedWebview = readCookie("webview_mode");
      const isWebView = !!savedWebview || !!navigator.userAgent.match(/WBKWebView/i);
      for (const subscriber of subscribers) {
        subscriber.setDevice(isWebView ? "app" : "web");
      }
    }
  }, [subscribers]);
  useEffect(() => {
    if (currentLocation) {
      for (const subscriber of subscribers) {
        subscriber.pageView();
      }
    }
  }, [currentLocation]);
  useEffect(() => {
    const consent = getItem(CONSENT_COOKIE_NAME);
    if (!consent) {
      return setShowConsent(true);
    }
    const parsed = safeParseJson(consent);
    const EXPIRY_DURATION = 2 * 24 * 60 * 60 * 1e3;
    const isDenied = Object.values(parsed).some((v) => v === "denied");
    const isExpired = (/* @__PURE__ */ new Date()).getTime() - new Date(parsed.date).getTime() > EXPIRY_DURATION;
    setShowConsent(isDenied && isExpired);
  }, []);
  const setCookieConsent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.setCookieConsent(props);
    }
    setShowConsent(false);
  };
  const pageView = () => {
    for (const subscriber of subscribers) {
      subscriber.pageView();
    }
  };
  const signupEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.signupEvent(props);
      subscriber.setUser(props.user);
    }
  });
  const loginEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.loginEvent(props);
      subscriber.setUser(props.user);
    }
  });
  const setUser = (props) => {
    for (const subscriber of subscribers) {
      subscriber.setUser(props);
    }
  };
  const logoutEvent = () => {
    for (const subscriber of subscribers) {
      subscriber.logoutEvent();
    }
  };
  const viewItemEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.viewItemEvent(props);
    }
  });
  const viewItemListEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.viewItemListEvent(props);
    }
  };
  const registerInterestEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.registerInterestEvent(props);
    }
  };
  const generateLeadEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.generateLeadEvent(props);
    }
  };
  const viewItemBook = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.viewItemBook(props);
    }
  });
  const cartEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.cartEvent(props);
    }
  };
  const viewSummaryEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.viewSummaryEvent(props);
    }
  };
  const ticketsSummaryEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.ticketsSummaryEvent(props);
    }
  };
  const paymentSummaryEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.paymentSummaryEvent(props);
    }
  };
  const beginCheckout = (props) => {
    for (const subscriber of subscribers) {
      subscriber.beginCheckout(props);
    }
  };
  const purchaseEvent = (props) => __async(void 0, null, function* () {
    for (const subscriber of subscribers) {
      subscriber.purchaseEvent(props);
    }
  });
  const purchaseSubscriptionEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.purchaseSubscriptionEvent(props);
    }
  };
  const purchaseFailed = (props) => {
    for (const subscriber of subscribers) {
      subscriber.purchaseFailed(props);
    }
  };
  const shareEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.shareEvent(props);
    }
  };
  const newsletterEvent = (props) => {
    for (const subscriber of subscribers) {
      subscriber.newsletterEvent(props);
    }
  };
  const trackEvent = (props) => {
    var _a;
    for (const subscriber of subscribers) {
      (_a = subscriber.trackEvent) == null ? void 0 : _a.call(subscriber, props);
    }
  };
  const clearCart = () => {
    for (const subscriber of subscribers) {
      subscriber.clearCart();
    }
  };
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: {
        showConsent,
        setCookieConsent,
        signupEvent,
        loginEvent,
        logoutEvent,
        setUser,
        viewItemEvent,
        viewItemListEvent,
        generateLeadEvent,
        viewItemBook,
        cartEvent,
        viewSummaryEvent,
        ticketsSummaryEvent,
        paymentSummaryEvent,
        beginCheckout,
        purchaseEvent,
        purchaseSubscriptionEvent,
        purchaseFailed,
        shareEvent,
        newsletterEvent,
        registerInterestEvent,
        pageView,
        trackEvent,
        clearCart
      },
      children
    }
  );
};
var provider_default = AnalyticsProvider;
export {
  provider_default as AnalyticsProvider,
  GtmTracker,
  MixpanelTracker,
  PostHogTracker,
  ReactNativeTracker,
  WbkTracker,
  useAnalytics_default as useAnalytics,
  useCookieConsent
};
//# sourceMappingURL=index.mjs.map